import { pickBy } from 'lodash'

import { getContentBaseRoute } from '@src/mappers/media/media-tile.mapper'

const FACEBOOK_SHARE_LINK = 'https://www.facebook.com/sharer/sharer.php'
const TWITTER_SHARE_LINK = 'https://twitter.com/intent/tweet'
export const ICID_HOSTS = ['www.teambeachbody.com', 'www.shakeology.com', 'www.beachbody.com']

export enum SHARE_PLATFORMS {
  CopyLink = 'copy link',
  Email = 'email',
  Facebook = 'facebook',
  Twitter = 'twitter',
}

function openNewWindow(
  url: string,
  target: string,
  position?: {
    width: number
    height: number
    top?: number
    right: number
    bottom: number
    left?: number
  }
) {
  const { outerHeight, outerWidth, open } = window
  // Window.open supports only top and left positions.
  // Added also bottom and right to allow values like bottom: 0
  if (position) {
    const { width, height, top, right, bottom, left } = position
    const topPosition = top ?? outerHeight - height - bottom
    const leftPosition = left ?? outerWidth - width - right
    return open(
      url,
      target,
      `height=${height}, width=${width}, top=${topPosition}, left=${leftPosition}`
    )
  }
  return open(url, target)
}

export const TARGET = {
  SELF: '_self',
  BLANK: '_blank',
  PARENT: '_parent',
  TOP: '_top',
}

export enum ContentShareMethod {
  link = 'link',
  email = 'email',
  facebook = 'facebook',
  twitter = 'twitter',
}

export type ShareMethodOptions = {
  [key: string]: {
    label: string
    successLabel?: string
  }
}

export type ShareArgs = {
  url: string
  text?: string
  title?: string
}

export function copyLink({ url }: ShareArgs) {
  window.navigator.clipboard.writeText(url)
}

export function shareToFacebook({ url }: ShareArgs) {
  openNewWindow(assignUrlParams(FACEBOOK_SHARE_LINK, { u: url }), TARGET.BLANK, {
    width: 600,
    height: 750,
    bottom: 0,
    right: window.outerWidth / 2 - 300,
  })
}

export function shareToTwitter({ url, text = '' }: ShareArgs) {
  openNewWindow(
    assignUrlParams(TWITTER_SHARE_LINK, {
      url,
      text,
      via: 'beachbody',
    }),
    TARGET.BLANK
  )
}

export function shareByEmail({ url, title = '', text = '' }: ShareArgs) {
  const subject = encodeURIComponent(title)
  const body = encodeURIComponent(`${text}${url}`)
  window.location.href = `mailto:?subject=${subject}&body=${body}`
}

export function buildShareUrl(
  entity: Pick<CocoApi.BODiBlock | CocoApi.Compilation | CocoApi.Program, '_type' | 'slug'>
): string | null {
  if (typeof window === 'undefined') return null
  const baseRoute = getContentBaseRoute(entity._type)
  if (!baseRoute || !entity.slug) return null
  const { host, protocol } = new URL(window.location.href)
  return `${protocol}//${host}${baseRoute}/${entity.slug}`
}

function assignUrlParams(url: string, params: Record<string, string>, ICID: string | null = null) {
  const parsedUrl = new URL(url)

  if (parsedUrl.host && ICID_HOSTS.includes(parsedUrl.host) && ICID) {
    parsedUrl.searchParams.set('ICID', ICID)
  }

  const query = pickBy({
    ...params,
    ...Object.fromEntries(parsedUrl.searchParams),
  })

  parsedUrl.search = ''
  for (const [key, value] of Object.entries(query)) {
    parsedUrl.searchParams.set(key, String(value))
  }

  return parsedUrl.toString()
}
